import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import VerbSelect from '../formComponents/inputs/VerbSelect';

class TimeSelector extends PureComponent {
    static propTypes = {
        timeChange: PropTypes.func,
        periodChange: PropTypes.func,
        selectedTime: PropTypes.object,
        selectedPeriod: PropTypes.string
    };

    _createOptions = () => {
        const options = [];
        for (let hr = 0; hr < 12; hr += 1) {
            for (let j = 0; j < 46; j += 15) {
                let minutes = j;
                if (!j) {
                    minutes += '0';
                }

                options.push({
                    time: { hour: hr, minute: j },
                    label: `${hr === 0 ? hr + 12 : hr}:${minutes}`,
                    value: `${hr}-${j}`
                });
            }
        }
        return options;
    };

    render() {
        const { timeChange, periodChange, selectedTime, selectedPeriod } = this.props;
        return (
            <div className={`time-selector col-sm-12`}>
                <div className={`time-selector-inputs col-sm-12`}>
                    <VerbSelect
                        styleProps={`time-selector-inputs-hours col-sm-4`}
                        onChange={(option) => timeChange(option.time)}
                        placeholder={`Time`}
                        value={`${selectedTime.hour}-${selectedTime.minute}`}
                        options={this._createOptions()}
                    />
                    <div
                        onClick={() => periodChange('AM')}
                        className={cns(
                            `time-selector-inputs-period-option`,
                            { selected: selectedPeriod === 'AM' },
                            'col-sm-2'
                        )}
                    >
                        <div />
                    </div>
                    <div className={'time-label'}>AM</div>
                    <div
                        onClick={() => periodChange('PM')}
                        className={cns(
                            `time-selector-inputs-period-option`,
                            { selected: selectedPeriod === 'PM' },
                            'col-sm-2'
                        )}
                    >
                        <div />
                    </div>
                    <div className={'time-label'}>PM</div>
                </div>
            </div>
        );
    }
}

export default TimeSelector;
